/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { buildUrl } from "../../utils/bindUrl";
import {
  ICustomerRequester,
  IResponseListCustomerRequesters,
  IResponseShowCustomerRequester,
} from "../../interfaces/customerRequesters";
import qs from "qs";
import { api } from "../api/httpClient";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/customer-requesters";

// serializer padrão (arrays em brackets, ignora null/undefined)
const serialize = (p: any) =>
  qs.stringify(p, { arrayFormat: "brackets", skipNulls: true, encode: true });

export async function listCustomerRequesters({
  filter,
  includes,
  page,
  limit,
  select,
}: IListParams) {
  const { data } = await api.get<IResponseListCustomerRequesters>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function showCustomerRequester({
  id,
  includes,
}: {
  id: string | number;
  includes?: string[];
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowCustomerRequester>(url, {
    params: { includes },
    paramsSerializer: (params) => serialize(params),
  });
  return data;
}

export async function createCustomerRequester({
  customerRequester,
}: {
  customerRequester: ICustomerRequester;
}) {
  const { data } = await api.post<IResponseShowCustomerRequester>(BASE, {
    customerRequester,
  });
  return data;
}

export async function updateCustomerRequester({
  id,
  customerRequester,
}: {
  id: string | number;
  customerRequester: ICustomerRequester;
}) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowCustomerRequester>(url, {
    customerRequester,
  });
  return data;
}

export async function deleteCustomerRequester({ id }: { id: string | number }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  // validateStatus => true evita cair no interceptor de erro (toast automático)
  const resp = await api.delete(url, { validateStatus: () => true });
  return { status: resp.status, data: resp.data };
}
